import UserDetailsModal from "@/components/UserDetailsModal";
import { useAuth } from "@/contexts/AuthProvider";
import { useUserDetails } from "@/hooks/useUserDetails";
import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";

interface UserDetailConfigProps {
  showMissingFieldsOnly?: boolean;
}

interface UserDetailModalContextType {
  open: (props: UserDetailConfigProps) => void;
  close: () => void;
}

const UserDetailModalContext = createContext<
  UserDetailModalContextType | undefined
>(undefined);

export const UserDetailModalProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: userDetails, isLoading } = useUserDetails();
  const [showMissingFieldsOnly, setShowMissingFieldsOnly] = useState(false);
  const { token } = useAuth();
  const queryClient = useQueryClient();

  const [pendingOpen, setPendingOpen] = useState(false);

  const onSubmit = async (data: any) => {
    const response = await axios.put(
      `https://kaman.rest/api/auth/customer-info?${
        data.name ? `name=${data.name}` : ""
      }&${data.email ? `email=${data.email}` : ""}&${
        data.phone ? `phone=${data.phone}` : ""
      }&${
        data.birthdate
          ? `birthdate=${data.birthdate.toLocaleDateString("en-GB")}`
          : ""
      }`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );
    queryClient.invalidateQueries({ queryKey: ["userDetails", token] });

    console.log(response);

    close();
    toast.success("User details updated successfully");
  };

  useEffect(() => {
    console.log("pendingOpen", pendingOpen);
    console.log("userDetails", userDetails);
    console.log("showMissingFieldsOnly", showMissingFieldsOnly);
    if (pendingOpen) {
      if (
        showMissingFieldsOnly &&
        userDetails?.name &&
        userDetails?.email &&
        userDetails?.phone &&
        userDetails?.birthdate
      ) {
        setPendingOpen(false);
      } else {
        setIsOpen(true);
        setPendingOpen(false);
      }
    }
  }, [userDetails]);

  const open = ({
    showMissingFieldsOnly,
  }: {
    showMissingFieldsOnly?: boolean;
  }) => {
    setShowMissingFieldsOnly(showMissingFieldsOnly ?? false);
    if (isLoading) {
      setPendingOpen(true);
      return;
    }

    if (
      showMissingFieldsOnly &&
      userDetails?.name &&
      userDetails?.email &&
      userDetails?.phone &&
      userDetails?.birthdate
    ) {
      return;
    }

    setIsOpen(true);
    setShowMissingFieldsOnly(showMissingFieldsOnly ?? false);
  };
  const close = () => {
    setIsOpen(false);
  };

  return (
    <UserDetailModalContext.Provider value={{ open, close }}>
      {children}
      {!isLoading && (
        <UserDetailsModal
          open={isOpen}
          onClose={close}
          onSubmit={onSubmit}
          fullName={userDetails?.name}
          email={userDetails?.email}
          phone={userDetails?.phone}
          birthdate={userDetails?.birthdate}
          showMissingFieldsOnly={showMissingFieldsOnly}
        />
      )}
    </UserDetailModalContext.Provider>
  );
};

export const useUserDetailModal = () => {
  const context = useContext(UserDetailModalContext);
  if (context === undefined) {
    throw new Error(
      "useUserDetailModal must be used within a UserDetailModalProvider"
    );
  }
  return context;
};
